import { render } from "./StreamsManageAudiencePanelSetup.vue?vue&type=template&id=f775a4fe"
import script from "./StreamsManageAudiencePanelSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamsManageAudiencePanelSetup.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/StreamsDash/StreamsManageAudiencePanelSetup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f775a4fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f775a4fe', __exports__)) {
    api.reload('f775a4fe', __exports__)
  }
  
  module.hot.accept("./StreamsManageAudiencePanelSetup.vue?vue&type=template&id=f775a4fe", () => {
    api.rerender('f775a4fe', render)
  })

}


export default __exports__